export default {
  第: 'the',
  年: 'Year',
  届: '',
  开幕中: 'Opening',
  全部展览: 'All Exhibitions',
  热门推荐: 'Hot Recommendations',
  当前展次: 'Current Exhibition',
  参观数量: 'Visitor Count',
  国内: 'Domestic',
  国外: 'Overseas',
  国际: 'International',
  开幕日期: 'Opening Date',
  正在参展: 'Exhibitors',
  展览简介: 'Exhibition Introduction',
  供应链简介: 'Exhibition Introduction',
  展览范围: 'Exhibition Scope',
  产业覆盖: 'Exhibition Scope',
  照片直播: 'Photos',
  展览费用: 'Exhibition Fees',
  展馆信息: 'Venue Introduction',
  组织机构: 'Organizations',
  国内企业: 'Domestic Companies',
  境外企业: 'Overseas Companies',
  物品清单: 'Item List',
  注意事项: 'Attentions',
  场馆面积: 'Total Area',
  国家地区: 'Country/Region',
  展览面积: 'Exhibition Area',
  展馆地址: 'Venue Address',
  当前届次: 'Current Edition',
  举办周期: 'Frequency',
  主办单位: 'Hosts',
  支持单位: 'Supporters',
  协办单位: 'Co-Organizers',
  承办单位: 'Organizers',
  标准展位: 'Shell Scheme Booth',
  豪华标准展位: 'Deluxe Booth',
  空地: 'Raw Space',
  去申请认证: 'Verify Now',
  参展商报名: 'Exhibitor Registration',
  参观商报名: 'Visitor Registration',
  展台搭建: 'Booth Construction',
  该展览已下架: 'Exhibition removed.',
  该展览不存在: "Exhibition doesn't exist.",
  '您是参观商,不能申请展厅搭建': 'You are a Buyer, and therefore cannot apply for booth construction.',
  '您是服务商,不能申请展厅搭建': 'You are a Service Provider, and therefore cannot apply for booth construction.',
  报名成功: 'Registration Successful!',
  参观商参展提示: 'You are currently a Buyer. To exhibit at exhibitions, please verify as an Exhibitor first!',
  主办商参展提示: 'You are an Event Organizer and therefore can sign up as visitor only.',
  服务商参展提示: 'You are a Service Provider and therefore can sign up as visitor only.',
  开展时间: 'Date/Time',
  展览地点: 'Venue Address',
  参展提示长:
    'As soon as your registration is processed, the Organizer will contact and send you the admission ticket, transportation tips and other materials ',
  全部: 'All',
  电子电器: 'Electronic Devices & Electrical Appliances',
  机械工业: 'Machinery',
  五金塑料: 'Hardware & Plastics',
  家居用品: 'Household Products',
  综合其他: 'Other',
  数字经济: 'Digital Economy',
  创新环境: 'Innovation Milieu',
  高端装备制造: 'High-end Equipment Manufacturing',
  国际交流合作: 'International Exchange & Cooperation',
  新材料能源: 'New Materials & Energy',
  综合展览: 'Comprehensive Exhibition',
  暂无相关的云上展览: 'No matching virtual exhibitions yet. ',
  '参展商数量（预计参展数）': 'Exhibitor Count (Estimated)',
  请填写数字: 'Please enter a number.',
  '参观商数量（预计参观数）': 'Visitor Count (Estimated)',
  请输入组织机构: 'Please enter the organization.',
  请输入展馆信息: 'Please enter the venue information.',
  展品范围: 'Exhibition Scope',
  请输入展品范围: 'Please enter the exhibition scope.',
  选择头条内容: 'Select the top news content',
  参展数量: 'Exhibitor Count',
  相关资讯: 'Related News',
  相关展览: 'Related Exhibitions',
  距离展览开幕还有: 'Distance from the exhibition opening',
}
